import { privateRequest, type ApiResponse } from "../axios";

const ENDPOINTS = {
    GEOFENCE_MANAGEMENT: "api/UsersGeoFence",
    GEOFENCE_REPORT: "api/UsersGeoFence/Export",
    ADD_USER_GEOFENCE: "api/AssignUserGeoFence",
    REMOVE_USER_GEOFENCE: "api/RemoveUserGeoFence",
    USER_GEOFENCE_LOGS: "api/UsersGeoFence/Logs",
    USER_GEOFENCE_AREA_BYID: "api/GetGeoFencingAreaById",
    GEOFENCING_AREA: "api/GetGeoFencingArea"
}

export const getUserGeofence = async (payload: any): Promise<ApiResponse<any[]>> => {
    const response = await privateRequest.get<ApiResponse<any[]>>(ENDPOINTS.GEOFENCE_MANAGEMENT, { params: payload });
    return response.data;
};

export const getUserGeofenceReport = async (payload: any) => {
    const response = await privateRequest.post<ApiResponse<any>>(ENDPOINTS.GEOFENCE_REPORT, payload, { responseType: "arraybuffer" });
    return response;
};

export const addUserGeofences = async (payload: any): Promise<ApiResponse<any>> => {
    const response = await privateRequest.post<ApiResponse<any>>(ENDPOINTS.ADD_USER_GEOFENCE, payload);
    return response.data;
};

export const removeUserGeofences = async (payload: any): Promise<ApiResponse<any>> => {
    const response = await privateRequest.post<ApiResponse<any>>(ENDPOINTS.REMOVE_USER_GEOFENCE, payload);
    return response.data;
};

export const getUserGeofenceLogs = async (data:any ): Promise<ApiResponse<any>> => {    
    const response = await privateRequest.get<ApiResponse<any>>(ENDPOINTS.USER_GEOFENCE_LOGS,{params:data});
    return response.data;
}
export const getUserGeofenceAreaById = async (id: string | number): Promise<ApiResponse<any>> => {
    const response = await privateRequest.get<ApiResponse<any>>(ENDPOINTS.USER_GEOFENCE_AREA_BYID, { params: { id } });
    return response.data;
}   
export const getGeofencingArea = async (): Promise<ApiResponse<any>> => {    
    const response = await privateRequest.get<ApiResponse<any>>(ENDPOINTS.GEOFENCING_AREA);
    return response.data;
}


const GeofenceUserManagement = {
    getUserGeofence,
    getUserGeofenceReport,
    addUserGeofences,
    removeUserGeofences,
    getUserGeofenceLogs,
    getUserGeofenceAreaById,
    getGeofencingArea
}

export default GeofenceUserManagement;